/* =========================================================
   ITS MÖÖA — FOOTER
   Archivo: assets/mooa-footer.js
   ========================================================= */

(function () {

  function initMooaFooter() {

    var footers = document.querySelectorAll('.MooaFooter');

    if (!footers.length) return;


    footers.forEach(function (footer) {

      var toggles = footer.querySelectorAll('.MooaFooter__Toggle');


      toggles.forEach(function (toggle) {

        /*
         * Evita duplicar eventos si Shopify
         * vuelve a cargar la sección.
         */
        if (toggle.dataset.mooaFooterReady === 'true') {
          return;
        }

        toggle.dataset.mooaFooterReady = 'true';


        toggle.addEventListener('click', function () {

          /*
           * En escritorio el footer permanece
           * siempre abierto.
           */
          if (window.innerWidth > 640) {
            return;
          }


          var block = toggle.closest('.MooaFooter__Block');

          if (!block) return;


          var content = block.querySelector(
            '.MooaFooter__Collapsible'
          );

          if (!content) return;


          var isOpen =
            toggle.getAttribute('aria-expanded') === 'true';


          /*
           * Estado accesible del botón.
           */
          toggle.setAttribute(
            'aria-expanded',
            isOpen ? 'false' : 'true'
          );


          /*
           * La clase debe ir en el BLOQUE,
           * porque así está definido en el CSS:
           *
           * .MooaFooter__Block.is-open
           * .MooaFooter__Collapsible
           */
          block.classList.toggle(
            'is-open',
            !isOpen
          );

        });

      });

    });

  }


  /*
   * Primera carga.
   */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initMooaFooter
    );

  } else {

    initMooaFooter();

  }


  /*
   * Shopify Theme Editor.
   */

  document.addEventListener(
    'shopify:section:load',
    initMooaFooter
  );

})();